<template>
  <div id="userLayout" :class="['user-layout-wrapper']">
    <div class="container">
      <div class="main" ref="main">
        <div class="header" @click="pageReload">
          <img class="logo-img" src="../assets/logo-black.png" />
          <span class="title-span">授权系统</span>
        </div>

        <a-tabs defaultActiveKey="1" :animated="false" size="large" @change="resetForm">
          <a-tab-pane tab="账号登录" key="1">
            <a-form class="user-layout-login" :form="form">
              <a-form-item>
                <a-input
                  size="large"
                  type="text"
                  placeholder="请输入用户名"
                  v-decorator="[
                'userName',
                {rules: [{ required: true, message: '请输入用户名' }], validateTrigger: 'blur'}
              ]"
                >
                  <a-icon slot="prefix" type="user" :style="{ color: 'rgba(0,0,0,.25)' }" />
                </a-input>
              </a-form-item>

              <a-form-item>
                <a-input
                  size="large"
                  autocomplete="false"
                  placeholder="请输入密码"
                  v-decorator="[
                    'password',
                    {rules: [{ required: true, message: '请输入密码' }], validateTrigger: 'blur'}
                  ]"
                  type="password"
                  @keyup.enter="handleSubmit"
                >
                  <a-icon slot="prefix" type="lock" :style="{ color: 'rgba(0,0,0,.25)' }" />
                </a-input>
              </a-form-item>

              <a-form-item style="margin:-10px 0px;">
                <a-row type="flex" justify="space-between">
                  <a-checkbox
                    v-decorator="[
                      'remember',
                      {
                        valuePropName: 'checked',
                        initialValue: true,
                      },
                    ]"
                  >自动登录</a-checkbox>
                </a-row>
              </a-form-item>

              <a-form-item style="margin-top:24px">
                <a-button
                  class="login-button"
                  size="large"
                  type="primary"
                  :loading="loading_btn"
                  :disabled="loading_btn"
                  @click="handleSubmit"
                >登录</a-button>
              </a-form-item>
            </a-form>
          </a-tab-pane>

          <a-tab-pane tab="手机号登录" key="2">
            <a-form class="user-layout-login" :form="phoneLoginForm">
              <a-form-item>
                <a-input
                  size="large"
                  type="text"
                  placeholder="请输入手机号"
                  v-decorator="['phone',
                    {
                      rules: [
                        { required: true, message: '请输入手机号' },
                        { pattern: /^1[3|4|5|6|7|8|9]\d{9}$/, message: '请输入正确的手机号' },
                        
                      ], 
                      validateTrigger: 'blur'
                    }
                  ]"
                >
                </a-input>
              </a-form-item>

              <a-form-item>
                <a-row :gutter="16">
                  <a-col class="gutter-row" :span="16">
                    <a-input
                      size="large"
                      autocomplete="false"
                      placeholder="请输入验证码"
                      v-decorator="[
                        'code',
                        {rules: [{ required: true, message: '请输入验证码' }], validateTrigger: 'blur'}
                      ]"
                      type="text"
                      @keyup.enter="handleSubmitPhoneLogin"
                    >
                    </a-input>
                  </a-col>
                  <a-col class="gutter-row" :span="8">
                    <a-button class="code-btn" :disabled="isGetCode" @click="handleGetCode">{{ btnTips }}</a-button>
                  </a-col>
                </a-row>
              </a-form-item>

              <a-form-item style="margin-top:24px">
                <a-button
                  class="login-button"
                  size="large"
                  type="primary"
                  :loading="loading_btn"
                  :disabled="loading_btn"
                  @click="handleSubmitPhoneLogin"
                >登录</a-button>
              </a-form-item>
            </a-form>
          </a-tab-pane>

          <a-tab-pane tab="串号查询" key="3">
            <a-form class="user-layout-login" :form="anonymityForm">
              <a-form-item>
                <a-input
                  size="large"
                  type="text"
                  placeholder="请输入串号"
                  v-decorator="[
                    'serialNumber',
                    {rules: [{ required: true, message: '请输入串号' }], validateTrigger: 'blur'}
                  ]"
                  @keyup.enter="anonymitySubmit"
                ></a-input>
              </a-form-item>

              <a-form-item style="margin-top:24px">
                <a-button
                  size="large"
                  type="primary"
                  class="login-button"
                  :loading="loading_btn"
                  :disabled="loading_btn"
                  @click="anonymitySubmit"
                >查询</a-button>
              </a-form-item>
            </a-form>
          </a-tab-pane>

          <a-tab-pane tab="绑定操作" key="4">
            <a-form v-if="status===''" class="user-layout-login" :form="bindForm">
              <a-form-item>
                <a-select v-model="operation" size="large" :defaultActiveFirstOption="false">
                  <a-select-option value="bind">绑定硬件</a-select-option>
                  <a-select-option value="unbind">解绑硬件</a-select-option>
                </a-select>
              </a-form-item>

              <a-form-item>
                <a-input
                  size="large"
                  type="text"
                  placeholder="请输入串号"
                  v-decorator="[
                    'serialNumber',
                    {rules: [{ required: true, message: '请输入串号' }]}
                  ]"
                ></a-input>
              </a-form-item>

              <a-form-item>
                <a-input
                  size="large"
                  type="text"
                  placeholder="请输入串号密钥"
                  v-decorator="[
                    'serialCipher',
                    {rules: [{ required: true, message: '请输入串号密钥' }]}
                  ]"
                ></a-input>
              </a-form-item>

              <a-form-item v-if="operation==='bind'">
                <a-input
                  size="large"
                  type="text"
                  placeholder="请输入绑定硬件密文"
                  v-decorator="[
                    'bindCipher',
                    {rules: [{ required: true, message: '请输入绑定硬件密文' }, { min: 16, max: 16, message: '长度必须16个字符', trigger: 'blur' }]}
                  ]"
                  @keyup.enter="bindSubmit"
                ></a-input>
              </a-form-item>

              <a-form-item v-if="operation==='unbind'">
                <a-input
                  size="large"
                  type="text"
                  placeholder="请输入解绑硬件密文"
                  v-decorator="[
                    'unbindCipher',
                    {rules: [{ required: true, message: '请输入解绑硬件密文' }, { min: 16, max: 16, message: '长度必须16个字符', trigger: 'blur' }]}
                  ]"
                  @keyup.enter="bindSubmit"
                ></a-input>
              </a-form-item>

              <a-form-item style="margin-top:24px">
                <a-button
                  size="large"
                  type="primary"
                  class="login-button"
                  :loading="loading_btn"
                  :disabled="loading_btn"
                  @click="bindSubmit"
                >{{btnText}}</a-button>
              </a-form-item>
            </a-form>

            <a-result
              v-else
              :status="status"
              :title="`${btnText}${statusText}`"
              :sub-title="subTitle"
            >
              <template #extra>
                <a-button @click="reload">再次{{btnText}}</a-button>
              </template>
            </a-result>
          </a-tab-pane>
          
          <a-tab-pane tab="结果校验" key="5">
            <a-form class="user-layout-login" :form="checkForm">
              <a-form-item>
                <a-input
                  size="large"
                  type="text"
                  placeholder="请输入机号"
                  allow-clear
                  v-decorator="[
                    'serialNumber',
                    {rules: [{ required: true, message: '请输入机号' }]}
                  ]"
                  @keyup.enter="checkSubmit"
                ></a-input>
              </a-form-item>
              <!-- todo -->
              <a-form-item>
                <a-input
                  size="large"
                  type="text"
                  placeholder="请输入AHAICRC"
                  allow-clear
                  v-decorator="[
                    'ahaiCrc'
                  ]"
                  @keyup.enter="checkSubmit"
                ></a-input>
              </a-form-item>
              <a-form-item>
                <a-input
                  size="large"
                  type="text"
                  placeholder="请输入AHAISUM"
                  allow-clear
                  v-decorator="[
                    'ahaiSum',
                  ]"
                  @keyup.enter="checkSubmit"
                ></a-input>
              </a-form-item>
              <a-form-item style="margin-top:24px">
                <a-button
                  size="large"
                  type="primary"
                  class="login-button"
                  :loading="loading_btn"
                  :disabled="loading_btn"
                  @click="checkSubmit"
                >校验</a-button>
              </a-form-item>
            </a-form>
          </a-tab-pane>
        </a-tabs>

        <a-modal
          class="modal"
          title="结果校验"
          :width="800"
          :visible="checkVisible"
          :footer="null"
          @cancel="checkVisible = false"
          :getContainer="() => $refs['main']"
        >
          <a-descriptions bordered v-if="crcResponse">
            <a-descriptions-item label="打印时间">{{ crcResponse.printTime }}</a-descriptions-item>
          </a-descriptions>
          <a-descriptions class="mt10" bordered v-if="measureDataResponse">
            <a-descriptions-item label="测量时间">{{ measureTime }}</a-descriptions-item>
            <a-descriptions-item label="积分时间(s)">{{ tm }}</a-descriptions-item>
            <a-descriptions-item label="分析仪">{{ analyzer }}</a-descriptions-item>
            <a-descriptions-item label="频率计权" v-if="analyzer != 'ALL'">{{ frequencyWeight }}</a-descriptions-item>
            <a-descriptions-item label="时间计权">{{ timeWeight }}</a-descriptions-item>
            <a-descriptions-item label="统计" v-if="analyzer == 'STA'">{{ sta }}</a-descriptions-item>
            <a-descriptions-item label="灵敏度级(dB)">{{ lxdb }}</a-descriptions-item>
          </a-descriptions>
          <div class="check-box mt10" v-if="measureDataResponse">
            <div class="data-item" v-for="item in list" :key="item.unit">
              <div class="same no-bottom-b">{{ item.label }}</div>
              <div class="same no-bottom-b1">{{ item.value }}</div>
            </div>
          </div>
        </a-modal>
      </div>
      <GlobalFooter></GlobalFooter>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { bindDevice, unbindDevice, querysmsSend, parseData } from '../api/api'
import GlobalFooter from '../components/GlobalFooter'

const TIME = 5
const dataList = [
  { label: 'Leq,T(dB)', codeKey: 'leq', value: '' },
  { label: 'L10(dB)', codeKey: 'l10', value: '' },
  { label: 'L50(dB)', codeKey: 'l50', value: '' },
  { label: 'L90(dB)', codeKey: 'l90', value: '' },
  { label: 'LAE(dB)', codeKey: 'lae', value: '' },
  { label: 'Lmax(dB)', codeKey: 'lmax', value: '' },
  { label: 'Lmin(dB)', codeKey: 'lmin', value: '', },
  { label: 'SD(dB)', codeKey: 'sd', value: '' },

  { label: 'LAeq,T(dB)', codeKey: 'laeq', value: '' },
  { label: 'LAmax(dB)', codeKey: 'lamax', value: '', },
  { label: 'LAmin(dB)', codeKey: 'lamin', value: '', },
  { label: 'LCeq,T(dB)', codeKey: 'lceq', value: '', },
  { label: 'LCmax(dB)', codeKey: 'lcmax', value: '', },
  { label: 'LCmin(dB)', codeKey: 'lcmin', value: '' },
  { label: 'LZeq,T(dB)', codeKey: 'lzeq', value: '' },
  { label: 'LZmax(dB)', codeKey: 'lzmax', value: '', },
  { label: 'LZmin(dB)', codeKey: 'lzmin', value: '', },

  { label: '31.5Hz(dB)', codeKey: 'oct31_5', value: '', },
  { label: '63Hz(dB)', codeKey: 'oct63', value: '', },
  { label: '125Hz(dB)', codeKey: 'oct125', value: '', },
  { label: '250Hz(dB)', codeKey: 'oct250', value: '', },
  { label: '500Hz(dB)', codeKey: 'oct500', value: '', },
  { label: '1KHz(dB)', codeKey: 'oct1000', value: '', },
  { label: '2KHz(dB)', codeKey: 'oct2000', value: '', },
  { label: '4KHz(dB)', codeKey: 'oct4000', value: '', },
  { label: '8KHz(dB)', codeKey: 'oct8000', value: '', },
]
export default {
  name: 'login',

  components: {
    GlobalFooter
  },

  data() {
    return {
      form: this.$form.createForm(this),
      phoneLoginForm: this.$form.createForm(this),
      anonymityForm: this.$form.createForm(this),
      bindForm: this.$form.createForm(this),
      checkForm: this.$form.createForm(this),
      loading_btn: false,
      operation: 'bind',

      status: '',
      subTitle: '',
      btnTips: '获取验证码',
      time: TIME,
      isGetCode: false,
      checkVisible: false,
      list: [],
      measureTime: '',
      tm: '',
      analyzer: '',
      timeWeight: '',
      sta: '',
      frequencyWeight: '',
      lxdb: '',
      crcResponse: null,
      measureDataResponse: null
    }
  },

  computed: {
    btnText() {
      return this.operation === 'bind' ? '绑定' : '解绑'
    },

    statusText() {
      return this.status === 'success' ? '成功' : '失败'
    }
  },

  methods: {
    ...mapActions(['Login', 'phoneLogin']),

    pageReload() {
      document.location.reload()
    },

    handleSubmit() {
      this.loading_btn = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.Login(values)
            .then(res => {
              this.$router.push({ path: '/' })
            })
            .catch(err => {})
            .finally(() => {
              setTimeout(() => {
                this.loading_btn = false
              }, 500)
            })
        } else {
          setTimeout(() => {
            this.loading_btn = false
          }, 500)
        }
      })
    },

    // 手机号登录
    handleSubmitPhoneLogin() {
      this.loading_btn = true
      this.phoneLoginForm.validateFields((err, values) => {
        if (!err) {
          this.phoneLogin(values).then(() => {
            this.$router.push({ path: '/' })
          })
          .catch(err => {})
          .finally(() => {
            setTimeout(() => {
              this.loading_btn = false
            }, 500)
          })
        } else {
          setTimeout(() => {
            this.loading_btn = false
          }, 500)
        }
      })
    },

    // 获取短信验证码
    handleGetCode() {
      this.phoneLoginForm.validateFields(['phone'], (err, values) => {
        if (!err) {
          this.queryMsgCode(values)
          this.cutTime()
        } else {
          return false
        }
      })
    },

    // 获取短信验证码
    queryMsgCode(values) {
      const para = {
        userPhone: values.phone,
        smsType: 'LOGIN'
      }

      querysmsSend(para).then(({ error, response }) => {
        if (error.code == 0) {
          this.$message.success(error.msg)
        } else {
          this.$message.error(error.msg)
        }
      })
    },

    // 倒计时
    cutTime() {
      this.btnTips = `${this.time}s后重新获取`
      this.time--
      if (this.time == 0) {
        this.time = TIME
        this.btnTips = '获取验证码'
        this.isGetCode = false
      } else {
        this.isGetCode = true
        setTimeout(() => {
          this.cutTime()
        }, 1000)
      }
    },

    anonymitySubmit() {
      this.loading_btn = true
      this.anonymityForm.validateFields((err, values) => {
        if (!err) {
          this.$router.push({
            name: 'anonymity-query',
            params: {
              serialNumber: values.serialNumber
            }
          })
        }
      })
      setTimeout(() => {
        this.loading_btn = false
      }, 500)
    },

    bindSubmit() {
      this.loading_btn = true

      this.bindForm.validateFields((err, values) => {
        if (!err) {
          this.status = ''
          if (this.operation === 'bind') {
            bindDevice(values).then(res => {
              if (res.error.code === 0) {
                this.status = 'success'
                this.subTitle = `授权码：${res.response.authorizationCode}`
              } else {
                this.status = 'error'
                this.subTitle = res.error.msg
              }
            })
          } else if (this.operation === 'unbind') {
            unbindDevice(values).then(res => {
              if (res.error.code === 0) {
                this.status = 'success'
              } else {
                this.status = 'error'
                this.subTitle = res.error.msg
              }
            })
          }
        }
      })
      setTimeout(() => {
        this.loading_btn = false
      }, 500)
    },

    resetForm() {
      this.form.resetFields()
      this.anonymityForm.resetFields()
      this.bindForm.resetFields()
      this.checkForm.resetFields()
    },

    reload() {
      this.bindForm.resetFields()
      this.status = ''
    },

    // 查询结果校验
    checkSubmit() {
      this.checkForm.validateFields((err, values) => {
        if (!err) {
          parseData(values).then(({response}) => {
            const { crcResponse, measureDataResponse } = response

            this.crcResponse = crcResponse
            this.measureDataResponse = measureDataResponse

            if (measureDataResponse) {
              const { analyzer, data, frequencyWeight, measureTime, sta, timeWeight, tm } = measureDataResponse
              this.measureTime = measureTime
              this.tm = tm
              this.analyzer = analyzer
              this.timeWeight = timeWeight
              this.sta = sta
              this.frequencyWeight = frequencyWeight

              let arr = []
              dataList.forEach(item => {
                for (let key in data) {
                  if (key == 'lxdb') {
                    this.lxdb = data[key] ? data[key].toFixed(1) : data[key]
                  }
                  if (item.codeKey == key) {
                    if (analyzer == 'STA') {
                      if (item.codeKey == 'leq') {
                        item.label = 'Leq,T(dB)'
                      } else if (item.codeKey == 'lmax') {
                        item.label = 'Lmax(dB)'
                      } else if (item.codeKey == 'lmin') {
                        item.label = 'Lmin(dB)'
                      } else if (item.codeKey == 'lae') {
                        item.label = 'SEL(dB)'
                      }
                    }
                    if (analyzer == 'OCTL') {
                      if (item.codeKey == 'leq') {
                        item.label = 'LAeq,T(dB)'
                      } else if (item.codeKey == 'lmax') {
                        item.label = 'LAFmax(dB)'
                      } else if (item.codeKey == 'lmin') {
                        item.label = 'LAFmin(dB)'
                      }
                    }
                    item.value = data[key] ? data[key].toFixed(1) : data[key]
                    arr.push(item)
                  }
                }
              })
              this.list = arr
            }
            
            this.checkVisible = true
          })
        }
      })
    }
  }
}
</script>


<style lang="less" scoped>
/deep/ .ant-tabs-bar {
  margin-top: 32px;
  margin-bottom: 32px;
}

.container {
  width: 100%;
  min-height: 100vh;
  background: #f0f2f5 url(~@/assets/background.svg) no-repeat 50%;
  background-size: 100%;
  position: relative;
}
.main {
  padding-top: 15vh;
  width: 626px;
  margin: 0 auto;
  .header {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    .logo-img {
      height: 24px;
      margin-right: 16px;
      transform: translateY(1px);
    }

    .title-span {
      font-size: 24px;
      color: #080404;
      font-weight: bold;
    }
  }
  .user-layout-login {
    .forget-password {
      font-size: 14px;
      color: #1890ff;
      cursor: pointer;
      padding: 0;
      user-select: none;
    }

    button.login-button {
      padding: 0 15px;
      font-size: 16px;
      height: 40px;
      width: 100%;
    }

    .user-login-other {
      text-align: left;
      margin-top: 24px;
      line-height: 22px;

      .item-icon {
        font-size: 24px;
        color: rgba(0, 0, 0, 0.2);
        margin-left: 16px;
        vertical-align: middle;
        cursor: pointer;
        transition: color 0.3s;

        &:hover {
          color: #1890ff;
        }
      }

      .register {
        float: right;
      }
    }
    .code-btn {
      width: 100%;
      height: 40px;
    }
  }
}

/deep/ .modal .check-box {
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #e8e8e8;
  .data-item {
    // border-bottom: 1px solid #ddd;
    flex: 1;
  }
  .same {
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: 1px solid #e8e8e8;
    border-left: none;
    color: #111;
    &.no-bottom-b {
      border-bottom: none;
      background: #fafafa;
    }
    &.no-bottom-b1 {
      margin-bottom: -1px;
    }
  }
}
</style>
